/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-09 11:39:10
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Page, Layout, Icon, Stack } from '@shopify/polaris';
import { PlayCircleMajor, QuestionMarkMajor } from '@shopify/polaris-icons';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import SwitchLayoutForm from './switch-layout-form';
import { URL } from 'src/constants/links';
import DidYouKnow from 'src/components/views/switch-layout/did-you-know';
import BackUpNotice from 'src/components/views/switch-layout/back-up-notice';
import MainMenu from 'src/components/containers/main-menu';
import ExceededPlanNotification from 'src/components/containers/common/exceeded-plan-notifications';
import YoutubeModal from 'src/components/views/common/youtube-modal';

type State = {
  youtubeModal: boolean
};

class SwitchLayout extends Component<WithI18nProps, State> {
  state = {
    youtubeModal: false
  };

  render() {
    const { i18n } = this.props;
    const { youtubeModal } = this.state;

    return (
      <div className="BC-Page BC-Page__Layout-Switch">
        <MainMenu menuId="menu-theme-switch-layout" />
        <Page
          title={i18n.translate('AdminHTML.SwitchLayout.SwitchLayout.title')}
          titleMetadata={
            <Stack spacing="tight">
              <span className="titleMetadata">
                <a href={URL['SwitchFilterLayoutDoc']} target="_blank" rel="noopener noreferrer">
                  <Icon source={QuestionMarkMajor} color="base" />
                </a>
              </span>
              <span className="titleMetadata">
                <button onClick={this.handleOpenYoutubeModal}>
                  <Icon source={PlayCircleMajor} color="base" />
                </button>
              </span>
            </Stack>
          }>
          <Layout>
            <Layout.Section>
              <div className="BC-Container__Notifications">
                <DidYouKnow />

                {/* Sticky notification for exceeded plan */}
                <ExceededPlanNotification />

                <BackUpNotice />
              </div>
            </Layout.Section>
            <Layout.Section>
              <SwitchLayoutForm />
            </Layout.Section>
          </Layout>
        </Page>
        <YoutubeModal
          active={youtubeModal}
          embeddedURL={URL['SwitchFilterLayoutTut']}
          title={i18n.translate('AdminHTML.SwitchLayout.SwitchLayout.youtubeModal_Title')}
          onClose={this.handleCloseYoutubeModal}
        />
      </div>
    );
  }

  handleOpenYoutubeModal = () => this.setState({ youtubeModal: true });
  handleCloseYoutubeModal = () => this.setState({ youtubeModal: false });
}

export default withI18n()(SwitchLayout);
